import { render, staticRenderFns } from "./TheReportConfig.vue?vue&type=template&id=4735913b&scoped=true&"
import script from "./TheReportConfig.vue?vue&type=script&lang=js&"
export * from "./TheReportConfig.vue?vue&type=script&lang=js&"
import style0 from "./TheReportConfig.vue?vue&type=style&index=0&id=4735913b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4735913b",
  null
  
)

export default component.exports